import { useMemo } from "react";
import { LoadingView } from "../../../../components";
import { useGetObjectsChildren } from "../../../../hooks/useGetObjectsChildren";
import { AutomationObjectsFlexGridView } from "../../../components/Grid/AutomationObjectsFlexGridView";
import { PlantInsightApps } from "../../types";
import { useGetRelationsOutByIdQuery } from "../../../../services/objects";
import { ObjectBooleanTimeline } from "../../../../features/Charts/ObjectBooleanTimeline";
import { getTimeRangeFromTimespan } from "../../../../utils/timeUtils";
import { themedUseStyletron } from "../../../../theme/customTheme";
import { StyledDivider } from "baseui/divider";
import { ParagraphMedium } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { schema as schemaMultistate } from '../../../Devices/MultiState/types'
import MultiStateInsightsPanel from '../../../Devices/MultiState/InsightsPanel'
import { default as EnergyHeatmap } from "../../../ReportsAndStatistics/Energy/Heatmap/Heatmap";
import { MeterType } from "../../../../services/energyHeatmap";
import { VerticalStackPanel } from "../../../../components/Layout/StackPanel";


const InsightsPanel = (props: any) => {
    const [css, theme] = themedUseStyletron()
    const { children, isLoading, isSuccess, refetch } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const childs = useMemo(() => children?.filter((v: any) => PlantInsightApps.includes(v.schema)), [children]);
    const mstate = useMemo(() => children?.find((v: any) => v.schema === schemaMultistate), [children]);

    const { data: counters } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: 'IsMeasuredBy' }, { skip: !children })

    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);

    return (
        <LoadingView isLoading={isLoading} isSucess={isSuccess}>
            <ParagraphMedium><FormattedMessage id="PlantInsightsPanel.operatinghours" defaultMessage="Operating Hours" /></ParagraphMedium>
            <ObjectBooleanTimeline currentValue={props.isOn} onColor={theme.appColors.aggregate.on} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isOn'}></ObjectBooleanTimeline>
            {mstate &&
                <div>
                    <ParagraphMedium><FormattedMessage id="P_AirHandling.Plantswitch" defaultMessage="Plantswitch" /></ParagraphMedium>
                    <MultiStateInsightsPanel {...mstate}></MultiStateInsightsPanel>
                </div>}


            {(counters && counters.length > 0) &&
                <div>
                    <ParagraphMedium><FormattedMessage id="PlantInsightsPanel.energyHeatmap" defaultMessage="Energy Heatmap" /></ParagraphMedium>
                    <EnergyHeatmap {...counters[0]} typeFilter={[MeterType.Consumer, MeterType.FeedIn, MeterType.FeedOut, MeterType.Producer]}></EnergyHeatmap>
                </div>
            }


            {childs &&
                <>
                    <div className={css({ width: '100%' })}><StyledDivider $size='cell'></StyledDivider></div>
                    <AutomationObjectsFlexGridView small={props.small} items={childs} flexGridColumnCount={props.flexGridColumnCount}></AutomationObjectsFlexGridView>
                </>
            }

        </LoadingView>
   )
}

export default InsightsPanel
